import { render, staticRenderFns } from "./Comparisons.vue?vue&type=template&id=1f9d707a&scoped=true&"
import script from "./Comparisons.vue?vue&type=script&lang=js&"
export * from "./Comparisons.vue?vue&type=script&lang=js&"
import style0 from "./Comparisons.vue?vue&type=style&index=0&id=1f9d707a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9d707a",
  null
  
)

export default component.exports